export default __webpack_public_path__ + "static/media/red-flag-icon.eb4bdd48.svg";